import { ref, Ref } from 'vue';

export default class FaqItem {
	public isOpened: Ref<boolean> = ref(false);

	public toggle(): void {
		this.isOpened.value = !this.isOpened.value;
	}
}
